/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveResources from './receive-resources';

export default (query = { page : 1, limit : 20 }) => (dispatch) => {
    dispatch({
        type: actions.RESOURCES_REQUEST,
    });

    return cecSdk
        .resource()
        .list(query)
        .then((resources) => {
            dispatch({
                type: actions.RESOURCES_REQUEST_SUCCESS,
            });
            dispatch(receiveResources(resources));
            return resources;
        });
};
